import { Component } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { Switch } from "react-router-dom/cjs/react-router-dom.min";
import Home from "../pages/Home";
import Blog from "../pages/Blog";
import Profil from "../pages/Profil";
import Article from "../pages/Article";
import Boutique from "../pages/Boutique";
import Login from "../pages/Login";
import Waitime from "../pages/Waitime";
import WaitimeHisto from "../pages/WaitimeHisto";
import Header from "./Header";
import Footer from "./Footer";
import TchatBtn from "./TchatBtn";
import Tchat from "./Tchat";
import { getIdentite } from "../actions/identite";
import { connect } from "react-redux";
import AdminActus from "../pages/admin/AdminActus";
import AdminActuAdd from "../pages/admin/AdminActuAdd";
import AdminActuEdit from "../pages/admin/AdminActuEdit";
import AdminGallerie from "../pages/admin/AdminGallerie";
import AdminGallerieAdd from "../pages/admin/AdminGallerieAdd";
import AdminGallerieEdit from "../pages/admin/AdminGallerieEdit";
import AdminIdentite from "../pages/admin/AdminIdentite";
import AdminHomeCtct from "../pages/admin/AdminHomeCtct";
import AdminCtct from "../pages/admin/AdminCtct";
import Alert from "./Alert";
import AdminRidesList from "../pages/admin/AdminRidesList";
import AdminRidesAdd from "../pages/admin/AdminRidesAdd";
import AdminRidesEdit from "../pages/admin/AdminRidesEdit";
import AdminParcsList from "../pages/admin/AdminParcsList";
import AdminParcsAdd from "../pages/admin/AdminParcsAdd";
import AdminParcsEdit from "../pages/admin/AdminParcsEdit";
import AdminParcRide from "../pages/admin/AdminParcRide";
import Error404 from "../pages/Error404";
import Polconf from "../pages/Polconf";
import MentLeg from "../pages/MentLeg";
import { getIp } from "../actions/user";
import Maintenance from "../pages/Maintenance";
import AdminNews from "../pages/admin/AdminNews";
import AdminProject from "../pages/admin/AdminProject";
import AdminProjectAdd from "../pages/admin/AdminProjectAdd";
import AdminFolders from "../pages/admin/AdminFolders";

class App extends Component {
    state = {
        openMessage: false,
        idtt: {
            name: "Discovride",
            slug: "discovride",
            logo: "default.png",
            desc: "Créateur de contenu, passionné de parcs d'attractions."
        },
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        ip: false,
        ipStart: true,
        reduceHdr: false,
        canContinueTchat: false,
        canContinue: false,
        activeMenu: false
    }

    componentDidMount() {
        this.props.getIdentite();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.redGetIdtt != this.props.redGetIdtt &&
            this.props.redGetIdtt.datas != null
        ) {
            this.setState({
                idtt: {
                    name: this.props.redGetIdtt.datas.name,
                    logo: this.props.redGetIdtt.datas.logo,
                    desc: this.props.redGetIdtt.datas.desc,
                    slug: this.props.redGetIdtt.datas.slug,
                },
            })
        
            if (this.state.ipStart) {
                this.props.getIp();
            } else {
                this.setState({canContinueTchat: true})
            }
        }

        if (
            prevProps.redUserIp.alert != this.props.redUserIp.alert
        ) {
            this.setState({
                ip: this.props.redUserIp.isCo,
                ipStart: false,
                canContinueTchat: true
            })
        }
    }

    handleContinue() {
        this.setState({canContinue: true});
    }

    handleReduceHdr(stt) {
        this.setState({
            reduceHdr: stt
        })
    }

    handleMenu(type) {
        this.setState({
            activeMenu: type
        })
    }

    render() {
        return <div className={`page ${this.state.reduceHdr && "page--reduce"}`} id="page">
            {/** Header **/}
            <Header handleReduceHdr={(stt) => this.handleReduceHdr(stt)} idtt={this.state.idtt} activeMenu={this.state.activeMenu} handleMenu={(type) => this.handleMenu(type)}/>
            {/** Content **/}
            {
                this.state.ip ?
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={(props) => (
                            <Home
                                {...props}
                                idtt={this.state.idtt}
                                canContinue={this.state.canContinue}
                                handleMenu={(type) => this.handleMenu(type)}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/actualites"
                        render={(props) => (
                            <Blog
                                {...props}
                                idtt={this.state.idtt}
                                canContinue={this.state.canContinue}
                                handleMenu={(type) => this.handleMenu(type)}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/profil"
                        render={(props) => (
                            <Profil
                                {...props}
                                idtt={this.state.idtt}
                                canContinue={this.state.canContinue} 
                                handleMenu={(type) => this.handleMenu(type)}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/article/:id"
                        render={(props) => (
                            <Article
                                {...props}
                                idtt={this.state.idtt}
                                canContinue={this.state.canContinue}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/boutique"
                        render={(props) => (
                            <Boutique
                                {...props}
                                idtt={this.state.idtt}
                                canContinue={this.state.canContinue}
                                handleMenu={(type) => this.handleMenu(type)}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/connexion"
                        render={(props) => (
                            <Login
                                {...props}
                                idtt={this.state.idtt}
                                canContinue={this.state.canContinue}
                                handleMenu={(type) => this.handleMenu(type)}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/temps-attente"
                        render={(props) => (
                            <Waitime
                                {...props}
                                idtt={this.state.idtt}
                                canContinue={this.state.canContinue}
                                handleMenu={(type) => this.handleMenu(type)}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/temps-d-attente-historique"
                        render={(props) => (
                            <WaitimeHisto
                                {...props}
                                idtt={this.state.idtt}
                                canContinue={this.state.canContinue}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/politique-de-confidentialite"
                        render={(props) => (
                            <Polconf
                                {...props}
                                idtt={this.state.idtt}
                                canContinue={this.state.canContinue}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/conditions-generales"
                        render={(props) => (
                            <MentLeg
                                {...props}
                                idtt={this.state.idtt}
                                canContinue={this.state.canContinue}
                            />
                        )}
                    />
                    {/** ===== Admin ===== **/}
                    {
                        (localStorage.getItem('userRole') != undefined &&
                        localStorage.getItem('userRole') == ['ROLE_SUPER_ADMIN'] ||
                        localStorage.getItem('userRole') == ['ROLE_ADMIN']) &&
                        <>
                            {/** Actus **/}
                            <Route
                                exact
                                path="/admin/actus"
                                render={(props) => (
                                    <AdminActus
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/admin/actus/ajout"
                                render={(props) => (
                                    <AdminActuAdd
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/admin/actus/edit/:id"
                                render={(props) => (
                                    <AdminActuEdit
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            {/** Gallerie **/}
                            <Route
                                exact
                                path="/admin/galerie"
                                render={(props) => (
                                    <AdminGallerie
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/admin/galerie/ajout"
                                render={(props) => (
                                    <AdminGallerieAdd
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/admin/galerie/edit/:id"
                                render={(props) => (
                                    <AdminGallerieEdit
                                        {...props}
                                        idtt={this.state.idtt} 
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            {/** Identité **/}
                            <Route
                                exact
                                path="/admin/identite"
                                render={(props) => (
                                    <AdminIdentite
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            {/** Contact **/}
                            <Route
                                exact
                                path="/admin/tchat"
                                render={(props) => (
                                    <AdminHomeCtct
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/admin/tchat/discussion/:ip"
                                render={(props) => (
                                    <AdminCtct
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            {/** Attractions **/}
                            <Route
                                exact
                                path="/admin/attractions"
                                render={(props) => (
                                    <AdminRidesList
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/admin/attraction/ajout/:id"
                                render={(props) => (
                                    <AdminRidesAdd
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/admin/attraction/edit/:id"
                                render={(props) => (
                                    <AdminRidesEdit
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            {/** Parcs **/}
                            <Route
                                exact
                                path="/admin/parcs"
                                render={(props) => (
                                    <AdminParcsList
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/admin/parc/ajout"
                                render={(props) => (
                                    <AdminParcsAdd
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/admin/parc/edit/:id"
                                render={(props) => (
                                    <AdminParcsEdit
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/admin/parc/attractions/:id"
                                render={(props) => (
                                    <AdminParcRide
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/admin/newsletter"
                                render={(props) => (
                                    <AdminNews
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            {/** =========== Code ================== **/}
                            {/** === Project **/}
                            {/** Liste **/}
                            <Route
                                exact
                                path="/admin/projects"
                                render={(props) => (
                                    <AdminProject
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            {/** Détail **/}
                            <Route
                                exact
                                path={`/admin/project/:id`}
                                render={(props) => (
                                    <AdminFolders
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            {/** Ajout **/}
                            <Route
                                exact
                                path="/admin/projects/ajout"
                                render={(props) => (
                                    <AdminProjectAdd
                                        {...props}
                                        idtt={this.state.idtt}
                                        canContinue={this.state.canContinue}
                                    />
                                )}
                            />
                            {/** === Fichier **/}
                            {/** Liste **/}
                            {/** Ajout **/}
                            {/** Editer **/}
                        </>
                    }
                    <Route render={(props) => (
                        <Error404 {...props} idtt={this.state.idtt}/>
                    )} />
                </Switch> :
                <Switch>
                    <Route render={(props) => (
                        <Maintenance {...props} idtt={this.state.idtt}/>
                    )} />
                </Switch>
            }
            

            {/** Footer **/}
            <Footer idtt={this.state.idtt} changeAlert={(alert) => this.setState({alert: alert})}/>

            {/** Tchat **/}
            <TchatBtn
                openMessage={this.state.openMessage}
                handleTchat={() => {this.setState({openMessage: !this.state.openMessage})}}
                changeAlert={(al) => this.setState({alert: al})}
                idtt={this.state.idtt}
                canContinueTchat={this.state.canContinueTchat}
                handleContinue={() => this.handleContinue()}
            />
            <Tchat
                idtt={this.state.idtt}
                openMessage={this.state.openMessage}
                handleTchat={() => {this.setState({openMessage: !this.state.openMessage})}}
                changeAlert={(al) => this.setState({alert: al})}
            />

            {/** Alert **/}
            <Alert alert={this.state.alert} />
        </div>
    }
}

const mapStateToProps = state => {
    return {
        redGetIdtt: state.redGetIdtt,
        redUserIp: state.redUserIp
    }
}

const mapDispatchToProps = {
    getIdentite,
    getIp
}

export default connect(mapStateToProps, mapDispatchToProps)(App);